module.exports = __webpack_public_path__ + "static/media/notifications-activer-active.00eb33c9.png";